<template>
    <div class="quote-detail-form">
        <!-- Dados de Contato -->
        <div class="form-section">
            <h3 class="section-title">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                Dados de Contato
            </h3>

            <div class="form-grid">
                <div class="form-group">
                    <label>WhatsApp</label>
                    <div class="readonly-field">{{ quoteDetail.whatsApp || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>E-mail</label>
                    <div class="readonly-field">{{ quoteDetail.email || '-' }}</div>
                </div>
            </div>
        </div>

        <!-- Dados Pessoais -->
        <div class="form-section">
            <h3 class="section-title">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                </svg>
                Dados Pessoais
            </h3>

            <div class="form-grid">
                <div class="form-group">
                    <label>Nome Completo</label>
                    <div class="readonly-field">{{ quoteDetail.clientName || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>CPF</label>
                    <div class="readonly-field">{{ formatCpf(quoteDetail.cpf) || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Número da CNH</label>
                    <div class="readonly-field">{{ quoteDetail.cnhNumber || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Validade da CNH</label>
                    <div class="readonly-field">{{ formatDate(quoteDetail.cnhExpiration) || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Data de Emissão da CNH</label>
                    <div class="readonly-field">{{ formatDate(quoteDetail.cnhIssueDate) || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Data de Nascimento</label>
                    <div class="readonly-field">{{ formatDate(quoteDetail.birthDate) || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Sexo</label>
                    <div class="readonly-field">{{ getGenderText(quoteDetail.sex) || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>CEP</label>
                    <div class="readonly-field">{{ formatCep(quoteDetail.zipCodeHome) || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Possui condutor menor de idade</label>
                    <div class="readonly-field">{{ quoteDetail.hasEarlyAgeDriver ? 'Sim' : 'Não' }}</div>
                </div>
            </div>
        </div>

        <!-- Dados do Veículo -->
        <div class="form-section">
            <h3 class="section-title">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                    <line x1="8" y1="21" x2="16" y2="21"></line>
                    <line x1="12" y1="17" x2="12" y2="21"></line>
                </svg>
                Dados do Veículo
            </h3>

            <div class="form-grid">
                <div class="form-group">
                    <label>Placa</label>
                    <div class="readonly-field">{{ quoteDetail.licensePlate || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>RENAVAM</label>
                    <div class="readonly-field">{{ quoteDetail.renavam || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Chassi</label>
                    <div class="readonly-field">{{ quoteDetail.chassis || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Marca</label>
                    <div class="readonly-field">{{ quoteDetail.brand || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Modelo</label>
                    <div class="readonly-field">{{ quoteDetail.model || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Ano</label>
                    <div class="readonly-field">{{ quoteDetail.year || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Cor</label>
                    <div class="readonly-field">{{ quoteDetail.color || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Tipo de Combustível</label>
                    <div class="readonly-field">{{ quoteDetail.fuelType || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Tipo de Veículo</label>
                    <div class="readonly-field">{{ getVehicleTypeText(quoteDetail.vehicleType) || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Valor FIPE</label>
                    <div class="readonly-field">{{ formatCurrency(quoteDetail.fipeValue) || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Tipo de Uso</label>
                    <div class="readonly-field">{{ getUsageTypeText(quoteDetail.usageType) || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Veículo zero quilômetro</label>
                    <div class="readonly-field">{{ quoteDetail.isZeroKm ? 'Sim' : 'Não' }}</div>
                </div>
            </div>
        </div>


        <!-- Dados da Cotação -->
        <div class="form-section">
            <h3 class="section-title">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M9 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-4"></path>
                    <rect x="9" y="11" width="6" height="11"></rect>
                    <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"></path>
                </svg>
                Dados da Cotação
            </h3>

            <div class="form-grid">
                <div class="form-group">
                    <label>Identificador</label>
                    <div class="readonly-field">{{ quoteDetail.key || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Criado</label>
                    <div class="readonly-field">{{ formatDateTime(quoteDetail.createdDate) || '-' }}</div>
                </div>

                <div class="form-group">
                    <label>Atualizado</label>
                    <div class="readonly-field">{{ formatDateTime(quoteDetail.updateDate) || '-' }}</div>
                </div>

                <div class="form-group situation-group">
                    <label>Situação *</label>
                    <div class="select-wrapper">
                        <select v-model="editableSituation" class="situation-select">
                            <option value="1">Recebido</option>
                            <option value="2">Cotando</option>
                            <option value="3">Cotação Concluída</option>
                            <option value="4">Aprovado</option>
                            <option value="5">Rejeitado</option>
                            <option value="6">Arquivado</option>
                        </select>
                        <div class="select-arrow">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6,9 12,15 18,9"></polyline>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-actions">
                <button @click="saveSituation" :disabled="saving" class="btn-save">
                    <svg v-if="saving" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="spinner">
                        <line x1="12" y1="2" x2="12" y2="6"></line>
                        <line x1="12" y1="18" x2="12" y2="22"></line>
                        <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
                        <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
                        <line x1="2" y1="12" x2="6" y2="12"></line>
                        <line x1="18" y1="12" x2="22" y2="12"></line>
                        <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
                        <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
                    </svg>
                    <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                        <polyline points="17,21 17,13 7,13 7,21"></polyline>
                        <polyline points="7,3 7,8 15,8"></polyline>
                    </svg>
                    {{ saving ? 'Salvando...' : 'Salvar Situação' }}
                </button>
            </div>
        </div>

        <!-- Upload de Arquivos -->
        <div class="form-section">
            <h3 class="section-title">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14,2 14,8 20,8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10,9 9,9 8,9"></polyline>
                </svg>
                Arquivos da Cotação
            </h3>

            <!-- Área de Upload -->
            <div class="upload-section">
                <div class="upload-area" @click="triggerFileInput" @dragover.prevent @drop.prevent="handleDrop">
                    <input ref="fileInput" type="file" multiple @change="handleFileSelect" style="display: none" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.txt">
                    <div class="upload-content">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <polyline points="7,10 12,15 17,10"></polyline>
                            <line x1="12" y1="15" x2="12" y2="3"></line>
                        </svg>
                        <h4>Arraste arquivos aqui ou clique para selecionar</h4>
                        <p>Formatos aceitos: PDF, DOC, DOCX, JPG, PNG, GIF, TXT</p>
                        <p>Tamanho máximo: 10MB por arquivo</p>
                    </div>
                </div>

                <!-- Lista de arquivos selecionados para upload -->
                <div v-if="selectedFiles.length > 0" class="selected-files">
                    <h4>Arquivos selecionados para upload:</h4>
                    <div class="file-list">
                        <div v-for="(file, index) in selectedFiles" :key="index" class="file-item">
                            <div class="file-info">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                    <polyline points="14,2 14,8 20,8"></polyline>
                                </svg>
                                <div class="file-details">
                                    <span class="file-name">{{ file.name }}</span>
                                    <span class="file-size">{{ formatFileSize(file.size) }}</span>
                                </div>
                            </div>
                            <div class="file-actions">
                                <input v-model="fileDescriptions[index]" type="text" placeholder="Nome corretora" class="file-description-input" required @input="clearErrorStyle($event)">
                                <button @click="removeSelectedFile(index)" class="btn-remove">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <line x1="18" y1="6" x2="6" y2="18"></line>
                                        <line x1="6" y1="6" x2="18" y2="18"></line>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="upload-actions">
                        <button @click="uploadFiles" :disabled="uploading" class="btn-upload">
                            <svg v-if="uploading" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="spinner">
                                <line x1="12" y1="2" x2="12" y2="6"></line>
                                <line x1="12" y1="18" x2="12" y2="22"></line>
                                <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
                                <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
                                <line x1="2" y1="12" x2="6" y2="12"></line>
                                <line x1="18" y1="12" x2="22" y2="12"></line>
                                <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
                                <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
                            </svg>
                            <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                <polyline points="7,10 12,15 17,10"></polyline>
                                <line x1="12" y1="15" x2="12" y2="3"></line>
                            </svg>
                            {{ uploading ? 'Enviando...' : 'Enviar Arquivos' }}
                        </button>
                        <button @click="clearSelectedFiles" class="btn-cancel">Cancelar</button>
                    </div>
                    
                    <!-- Mensagem de erro -->
                    <div v-if="uploadError" class="upload-error">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="15" y1="9" x2="9" y2="15"></line>
                            <line x1="9" y1="9" x2="15" y2="15"></line>
                        </svg>
                        <span>{{ uploadError }}</span>
                    </div>
                </div>
            </div>

            <!-- Lista de arquivos já enviados -->
            <div v-if="uploadedFiles.length > 0" class="uploaded-files">
                <h4>Arquivos enviados:</h4>
                <div class="file-list">
                    <div v-for="file in uploadedFiles" :key="file.ide" class="file-item uploaded" :class="{ 'approved': file.approved }">
                        <div class="file-info">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                <polyline points="14,2 14,8 20,8"></polyline>
                            </svg>
                            <div class="file-details">
                                <div class="file-header">
                                    <span class="file-name">{{ file.fileName }}</span>
                                    <span v-if="file.approved" class="file-status approved">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <path d="M9 12l2 2 4-4"></path>
                                            <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"></path>
                                            <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"></path>
                                        </svg>
                                        Aprovado
                                    </span>
                                </div>
                                <span class="file-size">{{ formatFileSize(file.fileSize) }}</span>
                                <span v-if="file.description" class="file-description">{{ file.description }}</span>
                                <span class="file-date">{{ formatDateTime(file.uploadDate) }}</span>
                            </div>
                        </div>
                        <div class="file-actions">
                            <a :href="file.downloadUrl" target="_blank" class="btn-download">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                    <polyline points="7,10 12,15 17,10"></polyline>
                                    <line x1="12" y1="15" x2="12" y2="3"></line>
                                </svg>
                                Baixar
                            </a>
                            <button @click="deleteFile(file.ide)" class="btn-delete">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <polyline points="3,6 5,6 21,6"></polyline>
                                    <path d="M19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"></path>
                                </svg>
                                Excluir
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else-if="!loadingFiles" class="no-files">
                <p>Nenhum arquivo enviado ainda.</p>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../services/api'

export default {
    name: 'QuoteDetailForm',
    props: {
        quoteDetail: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            editableSituation: null,
            saving: false,
            selectedFiles: [],
            fileDescriptions: [],
            uploadedFiles: [],
            uploading: false,
            loadingFiles: false,
            uploadError: null
        }
    },
    watch: {
        quoteDetail: {
            handler(newVal) {
                if (newVal) {
                    this.editableSituation = newVal.situation
                    this.loadUploadedFiles()
                }
            },
            immediate: true
        }
    },
    mounted() {
        if (this.quoteDetail) {
            this.loadUploadedFiles()
        }
    },
    methods: {
        async saveSituation() {
            try {
                this.saving = true

                await api.put(`/vehicle-insurance/quotes/${this.quoteDetail.ide}/situation`, {
                    situation: parseInt(this.editableSituation)
                })

                // Emitir evento para o componente pai atualizar e recarregar dados
                this.$emit('situation-updated', parseInt(this.editableSituation))
                this.$emit('reload-quote-detail')

                alert('Situação atualizada com sucesso!')
            } catch (error) {
                console.error('Erro ao salvar situação:', error)
                alert('Erro ao salvar situação. Tente novamente.')
            } finally {
                this.saving = false
            }
        },
        formatDate(dateString) {
            if (!dateString) return ''
            const date = new Date(dateString)
            return date.toLocaleDateString('pt-BR')
        },

        formatDateTime(dateString) {
            if (!dateString) return ''
            const date = new Date(dateString)
            return date.toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            })
        },

        formatCpf(cpf) {
            if (!cpf) return ''
            return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
        },

        formatCep(cep) {
            if (!cep) return ''
            return cep.replace(/(\d{5})(\d{3})/, '$1-$2')
        },

        formatCurrency(value) {
            if (!value) return ''
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value)
        },

        getGenderText(sex) {
            const genders = {
                1: 'Masculino',
                2: 'Feminino'
            }
            return genders[sex] || ''
        },

        getVehicleTypeText(vehicleType) {
            const types = {
                1: 'Carro',
                2: 'Moto',
                3: 'Caminhão',
                4: 'Ônibus',
                5: 'Van'
            }
            return types[vehicleType] || ''
        },

        getUsageTypeText(usageType) {
            const usageTypes = {
                1: 'Particular',
                2: 'Comercial',
                3: 'Táxi',
                4: 'Uber/99',
                5: 'Aluguel'
            }
            return usageTypes[usageType] || ''
        },

        getSituationText(situation) {
            const situations = {
                1: 'Recebido',
                2: 'Cotando',
                3: 'Cotação Concluída',
                4: 'Aprovado',
                5: 'Rejeitado',
                6: 'Arquivado'
            }
            return situations[situation] || 'Desconhecida'
        },

        // Métodos para upload de arquivos
        triggerFileInput() {
            this.$refs.fileInput.click()
        },

        handleFileSelect(event) {
            const files = Array.from(event.target.files)
            this.addFiles(files)
        },

        handleDrop(event) {
            const files = Array.from(event.dataTransfer.files)
            this.addFiles(files)
        },

        addFiles(files) {
            const validFiles = files.filter(file => {
                const maxSize = 10 * 1024 * 1024 // 10MB
                const allowedTypes = [
                    'application/pdf',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    'image/jpeg',
                    'image/jpg',
                    'image/png',
                    'image/gif',
                    'text/plain'
                ]

                if (file.size > maxSize) {
                    alert(`Arquivo ${file.name} é muito grande. Tamanho máximo: 10MB`)
                    return false
                }

                if (!allowedTypes.includes(file.type)) {
                    alert(`Tipo de arquivo ${file.name} não é suportado`)
                    return false
                }

                return true
            })

            this.selectedFiles = [...this.selectedFiles, ...validFiles]
            this.fileDescriptions = [...this.fileDescriptions, ...new Array(validFiles.length).fill('')]
        },

        removeSelectedFile(index) {
            this.selectedFiles.splice(index, 1)
            this.fileDescriptions.splice(index, 1)
        },

        clearSelectedFiles() {
            this.selectedFiles = []
            this.fileDescriptions = []
            this.$refs.fileInput.value = ''
        },

        clearErrorStyle(event) {
            // Remove estilos de erro quando o usuário começa a digitar
            const input = event.target
            input.style.borderColor = '#d1d5db'
            input.style.boxShadow = 'none'
            input.classList.remove('error')
        },

        async uploadFiles() {
            if (this.selectedFiles.length === 0) return

            // Validar se todas as descrições foram preenchidas
            const emptyDescriptions = this.fileDescriptions.some((desc, index) => {
                if (!desc || desc.trim() === '') {
                    // Destacar o campo vazio
                    const inputs = document.querySelectorAll('.file-description-input')
                    if (inputs[index]) {
                        inputs[index].focus()
                        inputs[index].classList.add('error')
                    }
                    return true
                }
                return false
            })

            if (emptyDescriptions) {
                this.uploadError = 'Por favor, preencha o nome da corretora para todos os arquivos antes de enviar.'
                return
            }

            // Limpar erro anterior
            this.uploadError = null

            try {
                this.uploading = true
                const formData = new FormData()

                this.selectedFiles.forEach((file, index) => {
                    formData.append('files', file)
                    formData.append('descriptions', this.fileDescriptions[index].trim())
                })

                await api.post(`/vehicle-insurance/quotes/${this.quoteDetail.ide}/files`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })

                alert('Arquivos enviados com sucesso!')
                this.clearSelectedFiles()
                this.loadUploadedFiles()
            } catch (error) {
                console.error('Erro ao enviar arquivos:', error)
                alert('Erro ao enviar arquivos. Tente novamente.')
            } finally {
                this.uploading = false
            }
        },

        async loadUploadedFiles() {
            if (!this.quoteDetail?.ide) return

            try {
                this.loadingFiles = true
                const response = await api.get(`/vehicle-insurance/quotes/${this.quoteDetail.ide}/files`)
                this.uploadedFiles = response.data
            } catch (error) {
                console.error('Erro ao carregar arquivos:', error)
            } finally {
                this.loadingFiles = false
            }
        },

        async deleteFile(fileIde) {
            if (!confirm('Tem certeza que deseja excluir este arquivo?')) return

            try {
                await api.delete(`/vehicle-insurance/quotes/files/${fileIde}`)
                alert('Arquivo excluído com sucesso!')
                this.loadUploadedFiles()
            } catch (error) {
                console.error('Erro ao excluir arquivo:', error)
                alert('Erro ao excluir arquivo. Tente novamente.')
            }
        },

        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes'
            const k = 1024
            const sizes = ['Bytes', 'KB', 'MB', 'GB']
            const i = Math.floor(Math.log(bytes) / Math.log(k))
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
        }
    }
}
</script>

<style scoped>
.quote-detail-form {
    max-width: 100%;
    margin: 0 auto;
    padding: 0;
}

.form-section {
    margin-bottom: 2rem;
    background: #fff;
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.section-title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1.25rem;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 1.5rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #e5e7eb;
}

.form-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.5rem;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.form-group label {
    font-weight: 600;
    color: #374151;
    font-size: 0.875rem;
}

.readonly-field {
    padding: 0.75rem 1rem;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    color: #374151;
    font-size: 0.875rem;
    min-height: 2.75rem;
    display: flex;
    align-items: center;
}

.status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    font-weight: 600;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    width: fit-content;
}

.status-1 {
    background: #d4edda;
    color: #155724;
}

.status-2 {
    background: #cce5ff;
    color: #004085;
}

.status-3 {
    background: #fff3cd;
    color: #856404;
}

.status-4 {
    background: #d1ecf1;
    color: #0c5460;
}

.status-5 {
    background: #f8d7da;
    color: #721c24;
}

.status-6 {
    background: #e2e3e5;
    color: #383d41;
}

/* Estilos para a combo de situação melhorada */
.situation-group {
    position: relative;
}

.select-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
}

.situation-select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding: 0.875rem 3rem 0.875rem 1rem;
    background: white;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    color: #374151;
    font-size: 0.875rem;
    font-weight: 500;
    min-height: 3rem;
    transition: all 0.3s ease;
    width: 100%;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.situation-select:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1), 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
}

.situation-select:hover:not(:focus) {
    border-color: #9ca3af;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.situation-select.error {
    border-color: #ef4444;
    box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);
}

.select-arrow {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: #6b7280;
    transition: all 0.3s ease;
}

.situation-select:focus+.select-arrow {
    color: #3b82f6;
    transform: translateY(-50%) rotate(180deg);
}

.situation-select option {
    padding: 0.75rem;
    font-weight: 500;
    background: white;
    color: #374151;
}

.situation-select option:hover {
    background: #f3f4f6;
}

.situation-select option:checked {
    background: #3b82f6;
    color: white;
}

/* Estilos para diferentes situações */
.situation-select option[value="1"] {
    color: #155724;
}

.situation-select option[value="2"] {
    color: #004085;
}

.situation-select option[value="3"] {
    color: #856404;
}

.situation-select option[value="4"] {
    color: #0c5460;
}

.situation-select option[value="5"] {
    color: #721c24;
}

.situation-select option[value="6"] {
    color: #383d41;
}

/* Estilos antigos mantidos para compatibilidade */
.editable-field {
    padding: 0.75rem 1rem;
    background: white;
    border: 2px solid #e5e7eb;
    border-radius: 8px;
    color: #374151;
    font-size: 0.875rem;
    min-height: 2.75rem;
    transition: all 0.2s;
    width: 100%;
}

.editable-field:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.editable-field.error {
    border-color: #ef4444;
}


.form-actions {
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: 1px solid #e5e7eb;
    display: flex;
    justify-content: flex-end;
}

.btn-save {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    background: #10b981;
    color: white;
    border: none;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 0.875rem;
}

.btn-save:hover:not(:disabled) {
    background: #059669;
    transform: translateY(-1px);
}

.btn-save:disabled {
    background: #9ca3af;
    cursor: not-allowed;
    transform: none;
}

.spinner {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* Estilos para upload de arquivos */
.upload-section {
    margin-top: 1.5rem;
}

.upload-area {
    border: 2px dashed #d1d5db;
    border-radius: 12px;
    padding: 2rem;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background: #f9fafb;
}

.upload-area:hover {
    border-color: #3b82f6;
    background: #eff6ff;
}

.upload-area.dragover {
    border-color: #3b82f6;
    background: #dbeafe;
}

.upload-content h4 {
    margin: 1rem 0 0.5rem 0;
    color: #374151;
    font-size: 1.125rem;
    font-weight: 600;
}

.upload-content p {
    margin: 0.25rem 0;
    color: #6b7280;
    font-size: 0.875rem;
}

.selected-files {
    margin-top: 1.5rem;
    padding: 1rem;
    background: #f3f4f6;
    border-radius: 8px;
}

.selected-files h4 {
    margin: 0 0 1rem 0;
    color: #374151;
    font-size: 1rem;
    font-weight: 600;
}

.file-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.file-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    transition: all 0.2s;
}

.file-item:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.file-item.uploaded {
    background: #f9fafb;
    border-color: #d1d5db;
}

.file-item.approved {
    background: #f0fdf4;
    border-color: #10b981;
}

.file-info {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex: 1;
}

.file-details {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.file-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
}

.file-name {
    font-weight: 500;
    color: #374151;
    font-size: 0.875rem;
    flex: 1;
}

.file-status {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 500;
}

.file-status.approved {
    background: #d1fae5;
    color: #047857;
    border: 1px solid #a7f3d0;
}

.file-size {
    color: #6b7280;
    font-size: 0.75rem;
}

.file-description {
    color: #6b7280;
    font-size: 0.75rem;
    font-style: italic;
}

.file-date {
    color: #9ca3af;
    font-size: 0.75rem;
}

.file-actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.file-description-input {
    padding: 0.5rem;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 0.875rem;
    width: 200px;
}

.file-description-input:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.file-description-input:invalid {
    border-color: #ef4444;
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.file-description-input.error {
    border-color: #ef4444;
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
    animation: shake 0.5s ease-in-out;
}

@keyframes shake {
    0%, 100% { transform: translateX(0); }
    25% { transform: translateX(-5px); }
    75% { transform: translateX(5px); }
}

.btn-upload,
.btn-download,
.btn-delete,
.btn-remove,
.btn-cancel {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 6px;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-upload {
    background: #10b981;
    color: white;
}

.btn-upload:hover:not(:disabled) {
    background: #059669;
}

.btn-upload:disabled {
    background: #9ca3af;
    cursor: not-allowed;
}

.btn-download {
    background: #3b82f6;
    color: white;
    text-decoration: none;
}

.btn-download:hover {
    background: #2563eb;
}

.btn-delete,
.btn-remove {
    background: #ef4444;
    color: white;
}

.btn-delete:hover,
.btn-remove:hover {
    background: #dc2626;
}

.btn-cancel {
    background: #6b7280;
    color: white;
}

.btn-cancel:hover {
    background: #4b5563;
}

.upload-actions {
    display: flex;
    gap: 1rem;
    margin-top: 1rem;
    justify-content: flex-end;
}

.upload-error {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 1rem;
    padding: 0.75rem 1rem;
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 8px;
    color: #dc2626;
    font-size: 0.875rem;
    font-weight: 500;
}

.upload-error svg {
    flex-shrink: 0;
    color: #dc2626;
}

.uploaded-files {
    margin-top: 1.5rem;
}

.uploaded-files h4 {
    margin: 0 0 1rem 0;
    color: #374151;
    font-size: 1rem;
    font-weight: 600;
}

.no-files {
    text-align: center;
    padding: 2rem;
    color: #6b7280;
    font-style: italic;
}

@media (max-width: 768px) {
    .form-grid {
        grid-template-columns: 1fr;
    }

    .form-section {
        padding: 1rem;
    }

    .form-actions {
        justify-content: center;
    }

    .file-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }

    .file-actions {
        width: 100%;
        justify-content: space-between;
    }

    .file-description-input {
        width: 100%;
    }

    .upload-actions {
        flex-direction: column;
    }
}
</style>
